import React, { useCallback, useEffect, useState } from 'react';

import { FormCursos } from '../../components/FormCursos';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';
import MenuMain from '../../MenuMain';

import { AppFooter } from '../../AppFooter';

import api from '../../api/api';

export default function EditarCursosPage(props) {

    const [cursos, setCursos] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errorGettingCursos, setErrorGettingCursos] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [idCursos] = useState(props.match.params.id)

    const [tipos, setTipos] = useState([]);

    const getTipoCursos = async () => {
        try {
          const respTipo = await api.get(`tipo-cursos`);
    
          const tiposFormatados = respTipo.data.map((tipo) => ({
            label: tipo.nome,
            value: tipo.id
          }));
    
          setTipos(tiposFormatados);

        } catch (error) {
          console.log('Erro ao buscar tipos de curso:', error);
        }
      };
    
      useEffect(() => {
        getTipoCursos();
      }, []);

    const getCursos = useCallback(async () => {
        setIsLoading(true);

        try {
            const response = await api.get(`curso/${idCursos}`)            

            setCursos({
                'id': response.data.id,
                'nome': response.data.nome,
                'obs': response.data.obs,
                'sigla': response.data.sigla,
                'tipoId': response.data.tipoId            
            })

            setErrorGettingCursos(false)
        }
        catch (error) {
            setErrorMessage(error.toString())
            setErrorGettingCursos(true)
        }

        setIsLoading(false);
    }, [idCursos]);

    useEffect(() => {

        async function cursos() {
            await getCursos();
        };
        cursos();

    }, [getCursos])

    return (
        <>
            <MenuMain >
                {
                    errorGettingCursos ?
                        <ErrorRetrievingData
                            errorMessage={errorMessage}
                            retrieveFunction={() => getCursos(idCursos)}
                            isLoading={isLoading}
                        />
                        :
                        <FormCursos
                            defaultValues={cursos}
                            tipos={tipos}
                            isEditing={true}
                            isLoading={isLoading}
                        />
                }
            </MenuMain>
            <AppFooter />
        </>
    );
}